export const makeDeviceOutOfRequest = request => ({
  name: request.name,
  identifiers: [request.networkId],
  manufacturer: request.manufacturer,
  lastSeen: request.lastSeen,
});
